import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Moment from 'moment';
import { connect } from 'react-redux';
import DateTime from '_class/DateTime';
import { getUserAssessmentDates } from 'helpers/user';
import { deleteVerdict, getAssignmentAssessments, getPlanAssessments, getVerdictsForUser } from 'actions/verdicts';
import { getStudentAdjustmentsBySubject } from 'actions/additional_adjustments';
import Modal from 'containers/Modals/Modal';
import VerdictAssessmentsDisplay from 'containers/Verdict/Display/VerdictAssessmentsDisplay';
import InputVerdictForm from 'containers/Verdict/Form/VerdictForm';
import VerdictWidget from 'containers/Verdict/Display/VerdictWidget';
import VerdictDisplay from 'containers/Verdict/Display/VerdictDisplay';
import TeacherAdjustments from 'containers/AdditionalAdjustments/Display/TeacherAdjustments';
import StudentAdjustmentForm from 'containers/AdditionalAdjustments/Form/StudentAdjustmentForm';
import DatePickers from "./DatePickers";
import { Collapsible } from 'UI';
import { Button, Checkbox, Expandable, Icon, translate } from '@haldor/ui';

var VerdictForm = /*#__PURE__*/function (_Component) {
  _inherits(VerdictForm, _Component);

  var _super = _createSuper(VerdictForm);

  function VerdictForm(props) {
    var _this;

    _classCallCheck(this, VerdictForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_setContainer", function (element) {
      return _this.container = element;
    });

    _defineProperty(_assertThisInitialized(_this), "_setContent", function (element) {
      return _this.content = element;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props = _this.props,
          activeStudent = _this$props.activeStudent,
          course = _this$props.course;
      window.addEventListener('resize', _this.resize);

      _this.resize();

      var promises = [];
      promises.push(_this.props.getAssignmentAssessments(activeStudent.id, course.id));
      promises.push(_this.props.getPlanAssessments(activeStudent.id, course.id));
      promises.push(_this.props.getVerdictsForUser(activeStudent.id, course.id));
      Promise.all(promises).then(function () {
        _this.setState({
          loading: false
        }, function () {
          return _this.resize();
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "reload", function () {
      var _this$props2 = _this.props,
          activeStudent = _this$props2.activeStudent,
          course = _this$props2.course;

      _this.setState({
        loading: true
      });

      _this.props.getVerdictsForUser(activeStudent.id, course.id).then(function () {
        _this.setState({
          loading: false
        }, function () {
          return _this.resize();
        });
      });

      if (_this.props.reload != null) {
        _this.props.reload();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setLoading", function (loading) {
      _this.setState({
        loading: loading
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('resize', _this.resize);
    });

    _defineProperty(_assertThisInitialized(_this), "onExpandableChange", function () {
      _this.resize(); // Animation timing


      setTimeout(function () {
        return _this.resize();
      }, 50);
      setTimeout(function () {
        return _this.resize();
      }, 100);
      setTimeout(function () {
        return _this.resize();
      }, 150);
      setTimeout(function () {
        return _this.resize();
      }, 200);
      setTimeout(function () {
        return _this.resize();
      }, 250);
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (_ref) {
      var start = _ref.start,
          end = _ref.end;

      if (start == "Invalid date") {
        start = Moment().subtract(1, "years");
      }

      if (end == "Invalid date") {
        end = Moment().add(1, "years");
      }

      _this.setState({
        start: new DateTime(start).getDateStamp(),
        end: new DateTime(end).getDateStamp()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmitDates", function (event) {
      event.preventDefault();

      _this.setState({
        currentStart: _this.state.start,
        currentEnd: _this.state.end
      });
    });

    _defineProperty(_assertThisInitialized(_this), "resize", function () {
      if (_this.container == null || _this.content == null) {
        return false;
      }

      var height = window.innerHeight - 185;
      height = height - _this.container.scrollHeight;
      _this.content.style.maxHeight = height + 'px';
    });

    _defineProperty(_assertThisInitialized(_this), "deleteVerdict", function (id) {
      var course = _this.props.course;
      var userId = null;

      if (_this.props.userVerdicts != null && _this.props.userVerdicts.length > 0) {
        userId = _this.props.userVerdicts[0].userId;
      }

      return new Promise(function (resolve) {
        _this.setState({
          loading: true
        });

        _this.props.deleteVerdict(id).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.postSubmit();

                  if (!(userId != null)) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 4;
                  return _this.props.getVerdictsForUser(userId, course.id);

                case 4:
                  resolve(1);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onVerdictSubmit", function (values) {
      return new Promise(function (resolve) {
        var course = _this.props.course;
        values.userId = _this.state.activeStudent.id;
        values.courses = [{
          "courseCode": course.courseCode,
          "subjectCode": course.subjectCode,
          "courseID": course.id
        }];

        _this.setState({
          loading: true
        });

        if (values.id != null) {
          _this.props.updateVerdict(values).then(function () {
            _this.postSubmit(resolve);
          });
        } else {
          _this.props.createVerdict(values).then(function () {
            _this.postSubmit(resolve);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAdjustmentModal", function () {
      var _this$props3 = _this.props,
          course = _this$props3.course,
          group = _this$props3.group;

      if (_this.state.adjustmentModal == false) {
        _this.setState({
          adjustmentModal: !_this.state.adjustmentModal
        });
      } else {
        _this.setState({
          adjustmentModal: !_this.state.adjustmentModal
        });

        _this.props.getStudentAdjustmentsBySubject(group.id, course.subjectId, _this.props.activeStudent.id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderPublishedInformation", function (verdict) {
      var name = verdict.createdBy.firstName + ' ' + verdict.createdBy.lastName;

      if (verdict.editedBy != null) {
        name = verdict.editedBy.firstName + ' ' + verdict.editedBy.lastName;
      }

      if (new Date(verdict.published) < new Date(_this.props.end)) {
        return /*#__PURE__*/React.createElement("div", {
          className: "info-draft"
        }, /*#__PURE__*/React.createElement("span", {
          className: "draft-badge"
        }, _this.props.translate('published') + ': ' + name + ' • ' + new DateTime(verdict.published).getTimeStamp()), /*#__PURE__*/React.createElement("span", {
          className: "draft-badge",
          style: {
            marginLeft: '5px'
          }
        }, _this.props.translate('edited') + ": " + name + ' • ' + new DateTime(verdict.edited).getTimeStamp()));
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "info-draft"
        }, /*#__PURE__*/React.createElement("span", {
          className: "draft-badge"
        }, _this.props.translate('published') + ': ' + name + ' • ' + new DateTime(verdict.published).getTimeStamp()));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderDraftInformation", function (userVerdicts) {
      if (userVerdicts != null && userVerdicts.length > 0 && userVerdicts[0].status == 'VERDICT_DRAFT') {
        return /*#__PURE__*/React.createElement("div", {
          className: "info-draft"
        }, /*#__PURE__*/React.createElement("span", {
          className: "draft-badge",
          style: {
            color: 'red'
          }
        }, _this.props.translate('Draft')), /*#__PURE__*/React.createElement("span", {
          className: "draft-badge",
          style: {
            marginLeft: '5px',
            color: 'red'
          }
        }, _this.props.translate('created') + ": " + new DateTime(userVerdicts[0].created).getTimeStamp()), /*#__PURE__*/React.createElement("span", {
          className: "draft-badge",
          style: {
            marginLeft: '5px',
            color: 'red'
          }
        }, _this.props.translate('edited') + ": " + new DateTime(userVerdicts[0].edited).getTimeStamp()));
      } else {
        return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderAdjustmentModal", function () {
      var translate = _this.props.translate;

      if (!_this.props.services.additionalAdjustments) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.adjustmentModal,
        onClose: _this.toggleAdjustmentModal,
        title: translate('assign-adjustment')
      }, /*#__PURE__*/React.createElement(StudentAdjustmentForm, {
        onClose: _this.toggleAdjustmentModal,
        course: _this.props.course,
        userId: _this.props.activeStudent.id
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderVerdict", function (verdict, index) {
      if (verdict == null || verdict.status == 'VERDICT_DRAFT') {
        return null;
      }

      var date = _this.props.tenant.currentSchoolYear != null ? _this.props.tenant.currentSchoolYear : '2017-01-01';
      var start = new DateTime(date).getDateStamp();
      var end = new DateTime(verdict.published).getDateStamp();
      var verdictBefore = _this.props.userVerdicts[index + 1];

      if (verdictBefore != null) {
        start = new DateTime(verdictBefore.published).getDateStamp();
      }

      var course = _this.props.course;
      var trigger = /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 1
        }
      }, new DateTime(verdict.published).getLongDateWithTime()), /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 0
        }
      }, /*#__PURE__*/React.createElement(VerdictWidget, {
        verdict: verdict
      })));
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-entry",
        key: verdict.id
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: trigger,
        onChange: _this.onExpandableChange
      }, _this.renderPublishedInformation(verdict), /*#__PURE__*/React.createElement(VerdictDisplay, {
        verdict: verdict,
        reload: _this.reload,
        setLoading: _this.setLoading,
        course: course
      })));
    });

    _this.state = {
      adjustmentModal: false,
      start: getUserAssessmentDates().start,
      end: getUserAssessmentDates().end,
      currentStart: getUserAssessmentDates().start,
      currentEnd: getUserAssessmentDates().end,
      loading: true,
      showLearningGoals: true,
      showKnowledgeRequirements: true
    };
    _this.container = null;
    _this.content = null;
    return _this;
  }

  _createClass(VerdictForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          activeStudent = _this$props4.activeStudent,
          duplicate = _this$props4.duplicate,
          translate = _this$props4.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "form form-component verdict"
      }, this.renderAdjustmentModal(), /*#__PURE__*/React.createElement("div", {
        ref: this._setContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: "place-verdict-expandable"
      }, /*#__PURE__*/React.createElement(Expandable, {
        open: true,
        ignorePropsUpdate: true,
        title: translate('place-verdict'),
        onChange: this.onExpandableChange
      }, this.renderDraftInformation(this.props.userVerdicts), /*#__PURE__*/React.createElement(InputVerdictForm, {
        onSubmit: this.onVerdictSubmit,
        duplicate: duplicate,
        edit: false,
        activeStudent: activeStudent.id,
        deleteVerdict: this.deleteVerdict,
        userVerdicts: this.props.userVerdicts
      }))), this.props.services.additionalAdjustments ? /*#__PURE__*/React.createElement(Expandable, {
        title: translate('additional-adjustments'),
        onChange: this.onExpandableChange
      }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
        adjustments: this.props.studentAdjustmentsBySubject
      }), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          _this2.toggleAdjustmentModal();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", translate('assign-adjustment'))) : /*#__PURE__*/React.createElement("div", {
        className: "form form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-divider",
        style: {
          marginBottom: 40,
          marginTop: 15
        }
      })), this.props.userVerdicts != null && this.props.userVerdicts.length > 0 ? /*#__PURE__*/React.createElement(Expandable, {
        title: translate('past-verdicts'),
        onChange: this.onExpandableChange
      }, /*#__PURE__*/React.createElement("div", {
        className: "past-verdicts"
      }, this.props.userVerdicts.map(this.renderVerdict))) : null), /*#__PURE__*/React.createElement("div", {
        className: "verdict-assessments-container",
        ref: this._setContent
      }, /*#__PURE__*/React.createElement("div", {
        className: "inputs-container",
        style: {
          padding: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "df aic",
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(DatePickers, {
        startDate: this.state.start,
        endDate: this.state.end,
        onChange: this.onDateChange
      }), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onSubmitDates
      }, translate('Update'))), /*#__PURE__*/React.createElement("div", {
        className: "filters"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
        label: translate('Learning goals'),
        value: this.state.showLearningGoals,
        onChange: function onChange(active) {
          return _this2.setState({
            showLearningGoals: active
          });
        }
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
        label: translate('Knowledge requirements'),
        value: this.state.showKnowledgeRequirements,
        onChange: function onChange(active) {
          return _this2.setState({
            showKnowledgeRequirements: active
          });
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '1rem'
        }
      }, !this.state.loading ? /*#__PURE__*/React.createElement(VerdictAssessmentsDisplay, {
        studentId: activeStudent.id,
        start: this.state.currentStart,
        end: this.state.currentEnd,
        courseId: this.props.course.id,
        showGoals: this.state.showLearningGoals,
        showMatrices: this.state.showKnowledgeRequirements
      }) : null)));
    }
  }]);

  return VerdictForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    services: state.Services.availableServices,
    userVerdicts: state.Verdicts.user
  };
}

export default connect(mapStateToProps, {
  getStudentAdjustmentsBySubject: getStudentAdjustmentsBySubject,
  deleteVerdict: deleteVerdict,
  getAssignmentAssessments: getAssignmentAssessments,
  getPlanAssessments: getPlanAssessments,
  getVerdictsForUser: getVerdictsForUser
})(VerdictForm);